import React from 'react';
import { createRoot } from 'react-dom/client';

// Usecases react-router-dom
import { BrowserRouter } from "react-router-dom";

import './index.css';
import App from './App';

createRoot(document.getElementById('root'))
  .render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

